import { render } from "./LyricsWeArise.vue?vue&type=template&id=c601d1b2&scoped=true"
import script from "./LyricsWeArise.vue?vue&type=script&lang=js"
export * from "./LyricsWeArise.vue?vue&type=script&lang=js"

import "./LyricsWeArise.vue?vue&type=style&index=0&id=c601d1b2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c601d1b2"]])

export default __exports__